class AlertFactory {
}
class DefaultAlertFactory extends AlertFactory {
  create(data) {
    return void 0;
  }
}
export {
  AlertFactory,
  DefaultAlertFactory
};
//# sourceMappingURL=AlertFactory.js.map
